module.exports = __webpack_public_path__ + "assets/img/tabs5.e3561bf4.png";